import React from 'react'

import "katex/dist/katex.min.css"

export default ({ children }) => (
  <React.Fragment>
    {children}
  </React.Fragment>
)